import { Record } from 'immutable';

export default class ServiceRecord extends Record({
  id: null,
  name: null,
  parent: undefined,
  path: undefined,
  children: undefined,
  bookable: undefined,
  bookingCount: undefined,
  childCount: undefined,
  resourceCount: undefined,
  inquiryCount: undefined,
  activeInquiryCount: undefined,
  activeInquiryDateCount: undefined,
  links: undefined,
  deletedAt: null,
}) {
}
